import { FemaleSerifIcon, MaleSerifIcon } from "../../icons.js";
import { useTheme } from "@mui/material";
import { useTranslation } from "next-i18next";
import React from "react";
export const PlayersTable = ({ fullwidth = false, product, }) => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const TABLE_BORDER_WITH = "1px";
    const { playerConfigs } = product;
    return (React.createElement("table", { style: {
            borderCollapse: "collapse",
            marginTop: theme.spacing(3.5),
            marginBottom: theme.spacing(4),
            width: fullwidth ? "100%" : "unset",
        } },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { style: {
                        borderBottom: `${TABLE_BORDER_WITH} solid ${theme.palette.text.primary}`,
                        borderRight: `${TABLE_BORDER_WITH} solid ${theme.palette.text.primary}`,
                        padding: `${theme.spacing(0.5)} 0`,
                    } }),
                React.createElement("th", { style: {
                        borderBottom: `${TABLE_BORDER_WITH} solid ${theme.palette.text.primary}`,
                        padding: `0 ${theme.spacing(2.5)}`,
                        fontWeight: 400,
                        textAlign: "center",
                    } },
                    React.createElement(FemaleSerifIcon, { sx: {
                            color: "inherit",
                            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.65rem", lg: "1.75rem" },
                        } })),
                React.createElement("th", { style: {
                        borderBottom: `${TABLE_BORDER_WITH} solid ${theme.palette.text.primary}`,
                        fontWeight: 400,
                        padding: `0 ${theme.spacing(2.5)}`,
                        textAlign: "center",
                    } },
                    React.createElement(MaleSerifIcon, { fontSize: "small", sx: {
                            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.65rem", lg: "1.75rem" },
                        } })))),
        React.createElement("tbody", null, playerConfigs.map((config, ix) => (React.createElement("tr", { key: `player-config-${ix}` },
            React.createElement("th", { style: {
                    borderRight: `${TABLE_BORDER_WITH} solid ${theme.palette.text.primary}`,
                    fontWeight: "400",
                    padding: `${theme.spacing(0.5)} ${theme.spacing(3)} ${theme.spacing(0.5)} 0`,
                } },
                config.female + config.male,
                "\u00A0",
                t("persons", "Personen")),
            React.createElement("td", { style: { textAlign: "center" } }, config.female),
            React.createElement("td", { style: { textAlign: "center" } }, config.male)))))));
};
//# sourceMappingURL=players-table.js.map